import React, { useState } from 'react';

/** Image-only loading state for chat media. Stickers keep their existing renderer. */
const ChatImage = ({ src, alt = '', className = '', onClick, ...props }) => {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  return (
    <span className="relative inline-block overflow-hidden rounded-lg bg-gray-200">
      {!loaded && !failed && (
        <span className="absolute inset-0 min-h-[120px] min-w-[120px] animate-pulse bg-gray-200" aria-hidden="true" />
      )}
      {failed ? (
        <span className="flex min-h-[120px] min-w-[120px] items-center justify-center px-3 text-xs text-gray-500">
          Image unavailable
        </span>
      ) : (
        <img
          {...props}
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          className={`${className} transition-opacity duration-200 ${loaded ? 'opacity-100' : 'opacity-0'}`}
          onLoad={() => setLoaded(true)}
          onError={() => setFailed(true)}
          onClick={onClick}
        />
      )}
    </span>
  );
};

export default ChatImage;
